/** * Created by lobin on 2020/9/10. */
<template>
  <page :footerShow="false">
    <div class="partner-recharge">
      <div class="partner-recharge-head">
        <div class="partner-recharge-head_account">
          ￥<span>{{ partner.account }}</span>
          <h2>账户余额(元)</h2>
        </div>
      </div>
      <div class="partner-recharge-content">
        <van-field
          v-model="form.fee"
          placeholder="请输入或者选择一个充值金额"
        />
        <van-radio-group v-model="form.fee" direction="horizontal">
          <van-radio
            :name="item"
            :class="{ checked: form.fee === item }"
            v-for="item in list"
            :key="item"
            >{{ item }}</van-radio
          >
        </van-radio-group>
        <van-button
          type="primary"
          @click="geRechargeConfig"
          :loading="loading"
          :disabled="form.fee === ''"
          class="confirm"
          >确认充值</van-button
        >
      </div>
      <van-dialog
        v-model="showQrcode"
        title="微信扫码支付"
        confirm-button-text="支付完成"
        class="overdue-dialog"
        @confirm="handlePayCompleted"
      >
        <qr-code class="pay-img" :text="payQrcode" :size="200"></qr-code>
      </van-dialog>
    </div>
  </page>
</template>

<script type="text/babel">
import { partnerInfo, partnerRechargeConfig } from "@/apis/index";

export default {
  data() {
    return {
      showQrcode: false,
      payQrcode: "",
      partner: {},
      list: [10, 20, 50, 100, 200],
      partnerId: "",
      loading: false,
      form: {
        fee: "",
        present: 0
      }
    };
  },
  created() {
    const id = this.$route.query.partner;
    this.partnerId = id;
    if (id) {
      this.getPartnerInfo();
    }
  },
  computed: {
    noticeTitle() {
      return `${this.partner.name}您账户余额${this.partner.account}元`;
    }
  },
  methods: {
    async getPartnerInfo() {
      const data = await partnerInfo(this.partnerId);
      this.partner = data;
    },
    async geRechargeConfig() {
      this.loading = true;
      const data = await partnerRechargeConfig({
        fee: Number(this.form.fee),
        present: 0,
        partner: this.partnerId
      });
      console.log(data);
      this.payQrcode = data.url;
      this.showQrcode = true;
      this.loading = false;
    },
    handlePayCompleted() {
      this.showQrcode = false;
      this.getPartnerInfo();
    }
  }
};
</script>

<style lang="scss">
.partner-recharge {
  &-head {
    height: rem(160);
    background: #1db475;
    &_account {
      padding-top: rem(20);
      font-size: rem(24);
      color: #fff;
      font-weight: bold;
      text-align: center;
      span {
        font-size: rem(42);
      }
      h2 {
        margin: rem(10) 0 0 0;
        padding: 0;
      }
    }
  }
  &-content {
    text-align: center;
    width: rem(430);
    margin: rem(30) auto;
    .van-field {
      height: rem(54);
      font-size: rem(24);
      border: 1px solid #e1e3e6;
      border-radius: 2px;
      width: rem(430);
    }
    .van-radio-group {
      margin-top: rem(30);
      margin-left: -8px;
      margin-right: -8px;
      width: rem(452);
    }
    .van-radio {
      .van-radio__icon {
        display: none;
      }
      &.checked {
        .van-radio__label {
          background: #1db475;
          color: #fff;
        }
      }
      .van-radio__label {
        height: rem(60);
        width: rem(70);
        line-height: rem(60);
        font-size: rem(30);
        text-align: center;
        background: #f7f9fc;
        color: #a8aeb3;
      }
    }
  }
  .confirm.van-button {
    margin-top: rem(30);
    width: rem(432);
  }
}
.overdue-dialog {
  .van-dialog__content {
    padding: rem(20);
    text-align: center;
  }
}
.pay-img {
  width: rem(200);
  height: rem(200);
  margin: 0 auto;
}
</style>
